import { UserManagerSettings } from 'oidc-client-ts';

import { loadConfig } from '@utils/configLoader';

const config = await loadConfig();

// Hardcoded defaults — safe localhost values for local development.
// Any key present in config.json's `oidc` block overrides the corresponding
// default at runtime without requiring a rebuild.
const defaults: UserManagerSettings = {
  authority: 'https://auth-dev.simpacc.ca/',
  client_id: 'tuos-ui',
  redirect_uri: 'http://localhost:8080/',
  post_logout_redirect_uri: 'http://localhost:8080',
  silent_redirect_uri: 'http://localhost:8080/silent-renew.html',
  scope: 'openid profile tuos-api IdentityServerApi offline_access',
  automaticSilentRenew: false,
  monitorSession: false,
  accessTokenExpiringNotificationTimeInSeconds: 60,
};

export const oidcUserManagerSettings: UserManagerSettings = {
  ...defaults,
  ...config.oidc,
  // These are behavioural flags — never let config.json override them.
  automaticSilentRenew: false,
  monitorSession: false,
};
